import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverAnnualFee = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverAnnualFee) return null;
  return {
    id: 'annualFee',
    label: 'Annual Fee',
    value: marketplaceEntity.driverAnnualFee.value,
    description: undefined,
    labelTooltip: undefined,
    valueTooltip: undefined,
    valueTooltipHasHtml: false,
  };
};
